export default "__VITE_ASSET__hVI9PDLUKQk5OD$vTtc9yA__";